import React from 'react';
import { OutlinedEditFilter } from '@hose/eui-icons';
import DepartmentFilter from "../../data-grid/DepartmentFilter";
export var getColumnDepartment = function (cellRender) {
    return {
        filterDropdown: function (_a) {
            var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
            return (React.createElement(DepartmentFilterDropdown, { clearFilters: clearFilters, setSelectedKeys: setSelectedKeys, confirm: confirm, selectedKeys: selectedKeys }));
        },
        filterIcon: function () { return React.createElement(OutlinedEditFilter, { fontSize: 16, style: { color: 'var(--eui-icon-n2)' } }); },
        render: cellRender
    };
};
export var DepartmentFilterDropdown = function (_a) {
    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
    var handleChange = function (value) {
        setSelectedKeys(value);
    };
    var handleConfirm = function () {
        confirm();
    };
    var handleReset = function () {
        clearFilters();
        confirm();
    };
    return React.createElement(DepartmentFilter, { value: selectedKeys, onChange: handleChange, onOk: handleConfirm, onReset: handleReset });
};
export default getColumnDepartment;
